import React, { useEffect } from 'react';
import { authService } from './services/authService';
import { useNavigate } from 'react-router-dom';
import Config from '@/config';
import { LoginCompanyUserInfo } from '@/common/types/login';

type SpaceType = 'STARTUP' | 'INVESTOR' | 'INNOVATE';

const getSpaceUrl = (type: SpaceType, companyCode: string): string => {
  const urlMap: Record<SpaceType, string> = {
    STARTUP: `${Config.startupClientUrl}/${companyCode}/dashboard`,
    INVESTOR: `${Config.investorClientUrl}/${companyCode}/home`,
    INNOVATE: `${Config.innovateClientUrl}/${companyCode}/program/list`,
  };
  return urlMap[type];
};

const DefaultPage: React.FC = () => {
  const navigate = useNavigate();

  const checkLogin = async () => {
    const response = await authService.checkLogin();
    if (!response.success) {
      navigate('/login');
      return;
    }

    const profileResult = await authService.setUserProfile();
    if (!profileResult.success || !profileResult.data) {
      navigate('/my-space');
      return;
    }

    const companyUsers: LoginCompanyUserInfo[] = profileResult.data.companyUsers.filter(
      (cu) => Boolean(cu?.company),
    );

    if (companyUsers.length === 1) {
      const singleCompanyUser = companyUsers[0];
      const services = singleCompanyUser.company.services ?? [];

      if (services.length === 1 && singleCompanyUser.emailVerified) {
        const spaceType = services[0].type as SpaceType;
        const companyCode = singleCompanyUser.company.code;

        localStorage.setItem('lastSelectedCompanyCode', companyCode);
        localStorage.setItem('lastSelectedSpace', spaceType);

        window.location.href = getSpaceUrl(spaceType, companyCode);
        return;
      }
    }

    navigate('/my-space');
  };

  useEffect(() => {
    checkLogin();
  }, []);

  return null;
};

export default DefaultPage;
